// extracted by mini-css-extract-plugin
module.exports = {"app":"cursor_app__220jI"};